/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_LinkInputs */

const vi_shop_home_link = /** @type {(inputs: Shop_Home_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link khi bấm`)
};

/**

* @param {Shop_Home_LinkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_link = /** @type {((inputs?: Shop_Home_LinkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_LinkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_link(inputs)
});